(() => {
  if (!customElements.get('sn-card-choice')) customElements.define('sn-card-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const select = this.querySelector('[data-sn-card-variant]');
      const button = this.querySelector('[type="submit"]');
      if (!select || !button) return;
      select.addEventListener('change', () => {
        button.disabled = !select.value;
        const option = select.selectedOptions[0];
        const price = this.closest('.product-card-wrapper')?.querySelector('.card__information .price');
        if (!price || !select.value) return;
        const current = document.createElement('span');
        current.className = 'price-item sn-card-current';
        current.textContent = option.dataset.price;
        price.classList.remove('price--on-sale');
        price.replaceChildren(current);
        if (option.dataset.compare) {
          const previous = document.createElement('s');
          previous.className = 'price-item sn-card-previous';
          previous.textContent = option.dataset.compare;
          price.append(previous);
        }
      });
      button.disabled = !select.value;
    }
  });
  if (!customElements.get('sn-sticky-buy')) customElements.define('sn-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.source = this.root?.querySelector(`#product-form-${this.dataset.section}`);
      this.original = this.source?.querySelector('[name="add"]');
      if (!this.original) return;
      this.button = this.querySelector('[data-sticky-submit]');
      this.price = this.querySelector('[data-sticky-price]');
      this.chosen = this.dataset.needsChoice !== 'true' || this.dataset.chosen === 'true';
      this.media = window.matchMedia('(max-width: 749px)');
      this.onChange = event => {
        if (event.target.closest('variant-selects')) this.chosen = true;
        this.sync();
      };
      this.root.addEventListener('change', this.onChange);
      this.onMedia = () => this.sync();
      this.media.addEventListener('change', this.onMedia);
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.sync();
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      window.addEventListener('resize', this.onScroll, {passive: true});
      this.mutations = new MutationObserver(() => this.sync());
      this.mutations.observe(this.root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class']});
      this.button.addEventListener('click', () => {
        if (!this.chosen) {
          const picker = this.root.querySelector('variant-selects');
          if (picker) {
            picker.scrollIntoView({block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
            picker.querySelector('input:not([disabled]), select:not([disabled])')?.focus({preventScroll: true});
          }
          return;
        }
        this.original.click();
      });
      this.sync();
    }
    sync() {
      const visible = this.media.matches && this.original.getBoundingClientRect().bottom < 0;
      this.hidden = !visible;
      document.body.classList.toggle('sn-sticky-buy-visible', visible);
      const unavailable = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
      this.button.disabled = this.chosen && unavailable;
      this.button.textContent = !this.chosen ? this.dataset.choiceLabel.trim() : this.original.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
      const prices = this.root.querySelector(`#price-${this.dataset.section}`);
      const value = prices?.querySelector('.price--on-sale .price-item--sale') || prices?.querySelector('.price__regular .price-item--regular');
      if (value && this.price.textContent !== value.textContent.trim()) this.price.textContent = value.textContent.trim();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.mutations?.disconnect();
      this.root?.removeEventListener('change', this.onChange);
      this.media?.removeEventListener('change', this.onMedia);
      document.body.classList.remove('sn-sticky-buy-visible');
    }
  });
})();
